import router from '@/router/index.js'
import store from '@/store'
import { Message } from 'element-ui';
import { getToken } from '@/utils/auth' // get token from cookie


const whiteList = ['login', 'forgetPwd', 'register', 'appDown','m_appDown'] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  // determine whether the user has logged in
  const hasToken = getToken()
  if (hasToken) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({ path: '/' })
    } else {
      const hasGetUserInfo = store.getters.userInfo
      if (hasGetUserInfo) {
        next()
      } else {
        try {
          // 获取用户信息
          await store.dispatch('user/getInfo')
          next({ ...to, replace: true })
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch('user/resetToken')
          Message.error(error || 'Has Error')
          // next(`/login?redirect=${to.fullPath}`)
          next(`/login`)
        }
      }
    }
  } else {
    /* has no token*/
    console.log(to.name)
    if (whiteList.indexOf(to.name) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      // next(`/login?redirect=${to.fullPath}`)
      next(`/login`)
    }
  }
})
